import {inject} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {CanActivateFn, Router} from '@angular/router';
import {SessionService, User} from '@q9elements/ui-kit/common';
import {map, of, switchMap, tap, Observable, filter} from 'rxjs';

import {ROUTES_PATH} from '../models/routes-path.enum';
import {AuthDaoService} from '../services/auth-dao.service';
import {NavigationService} from '../services/navigation.service';

export const FirstLoginGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const authDaoService = inject(AuthDaoService);
  const navigationService = inject(NavigationService);
  const router = inject(Router);
  const user$ = toObservable(sessionService.user) as Observable<User>;

  return user$.pipe(
    filter(user => !!user),
    switchMap(user => {
      if (!user) {
        return of(router.createUrlTree(['']));
      }

      if (!user.isFirstLogin) {
        return of(true);
      }

      const hasSelectedProblems = !!user.problems?.length;

      if (!hasSelectedProblems && router.url.indexOf(ROUTES_PATH.PROBLEMS_SELECT) === -1) {
        return of(router.createUrlTree(['/', ROUTES_PATH.PROBLEMS_SELECT]));
      }

      if (hasSelectedProblems) {
        return authDaoService.updateProfile(user.id, {isFirstLogin: false}).pipe(
          tap(newUser => sessionService.user.set(newUser)),
          map(() => {
            navigationService.navigateToModule(ROUTES_PATH.METADATA_DICTIONARIES, {ref: 'active'});

            return true;
          })
        );
      }

      return of(true);
    })
  );
};
